import * as React from 'react';
import { Modal } from '@ixicare/ui';
import GeoJSON from 'geojson';
import { t } from '~/i18n';
import OutdoorGeofenceEditor from '~components/OutdoorGeofenceEditor';
import { InputContainer, InputLabel, Value } from './inputStyles';

interface Props {
  /** Where the map opens. Absent until the site has loaded, which is when the editor can open. */
  lat?: number;
  long?: number;
  /** The site's own perimeter, so a new one starts at the building rather than blank. */
  defaultPolygon?: GeoJSON.Feature<GeoJSON.Polygon>;
  value?: GeoJSON.Feature<GeoJSON.Polygon>;
  onChange: (geo?: GeoJSON.Feature<GeoJSON.Polygon>) => void;
}

/**
 * The GPS perimeter an alarm sender is judged against, drawn on a map.
 *
 * Takes the site's coordinates and its default perimeter rather than fetching them. The page knows
 * which site a resident belongs to and asks once; this control asking for itself meant the site was
 * fetched twice over, and the default perimeter came from whichever site the *viewer* belongs to.
 */
export default function PerimeterInput({ lat, long, defaultPolygon, value, onChange }: Props) {
  const [isEdit, setEdit] = React.useState(false);
  return (
    <InputContainer>
      <InputLabel>{t('profile-configuration.geofence.outdoor.geo.label')}</InputLabel>
      {/* Both Value fields are named, like the checkboxes and radios above them: the help-center
          screenshots open these editors, and their only text is translated. */}
      <Value id="geofence-perimeter" onClick={() => setEdit(true)}>
        {value
          ? t('profile-configuration.outdoor-geofencing-geo.edit')
          : t('profile-configuration.outdoor-geofencing-geo.empty')}
      </Value>

      {isEdit && lat !== undefined && long !== undefined && (
        <Modal onClose={() => setEdit(false)} style={{ maxWidth: 900 }}>
          <OutdoorGeofenceEditor
            residentSetting={true}
            onCancel={() => setEdit(false)}
            onSave={(x) => {
              setEdit(false);
              onChange(x);
            }}
            lat={lat}
            long={long}
            polygon={value}
            defaultPolygon={defaultPolygon}
          />
        </Modal>
      )}
    </InputContainer>
  );
}
